/**
 * Nursery lists read by crop: every lemon together, then the limes. The stock
 * items and products pages both group this way.
 */

/** Rows whose cultivar has no crop. Listed after every named crop. */
export const NO_CROP = 'No crop type';

export interface CropGroup<T> {
  crop: string;
  items: T[];
}

/** The rows under their crop: crops by name, "No crop type" last, each crop's rows in `compare` order. */
export function groupByCrop<T>(
  rows: T[],
  cropOf: (row: T) => string | null | undefined,
  compare: (a: T, b: T) => number,
): CropGroup<T>[] {
  const groups = new Map<string, T[]>();
  for (const row of rows) {
    const crop = cropOf(row)?.trim() || NO_CROP;
    const list = groups.get(crop);
    if (list) list.push(row);
    else groups.set(crop, [row]);
  }
  return [...groups.entries()]
    .sort(([a], [b]) => (a === NO_CROP ? 1 : b === NO_CROP ? -1 : a.localeCompare(b)))
    .map(([crop, list]) => ({ crop, items: [...list].sort(compare) }));
}
